export default "__VITE_ASSET__YhnKsyXx__"